import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(VDataTable, {
        key: _vm.keyTable2,
        staticClass: "text-center table-inca",
        attrs: {
          responsive: "",
          dense: "",
          items: _vm.logItems,
          headers: _vm.logHeaders,
          "hide-default-footer": "",
          "items-per-page": _vm.pagination.attributes.limit,
          page: _vm.pagination.attributes.current,
          "sort-by": _vm.pagination.attributes.sort_by,
          "sort-desc": _vm.pagination.attributes.sort_desc,
        },
        on: {
          pagination: function ($event) {
            _vm.pagination.attributes.total = $event.itemsLength
          },
          "update:page": function ($event) {
            return _vm.$set(_vm.pagination.attributes, "current", $event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item.creation_date",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(VIcon, [_vm._v(" mdi-calendar ")]),
                _vm._v(
                  " " +
                    _vm._s(_vm.getDateAndHours(item.creation_date).date) +
                    " "
                ),
                _c(VIcon, [_vm._v(" mdi-clock-outline ")]),
                _vm._v(
                  " " +
                    _vm._s(_vm.getDateAndHours(item.creation_date).hour) +
                    " "
                ),
              ]
            },
          },
          {
            key: "item.status_id",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(
                  VChip,
                  {
                    attrs: {
                      small: "",
                      "text-color": _vm.getUseCaseStatus(item.status_id)
                        .textColor,
                      color: _vm.getUseCaseStatus(item.status_id).color,
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getUseCaseStatus(item.status_id).status) +
                        " "
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("pagination-vue", {
        attrs: { pagination: _vm.pagination.attributes },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }